import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Pause, BookOpen, ClipboardCheck, MailCheck, ArrowLeft, Award, Video } from 'lucide-react';

const ModuleMenu = ({ module, moduleId, navigateToPage, handleContents, handleVideo, isPlaying, togglePlay, onImage, handleBack, currentTime, duration, onSeek, isMobile, hasVideo }) => {
    const navigate = useNavigate();
    const iconSize = isMobile ? 20 : 24;

    useEffect(() => {
        if (moduleId === 'epilogue') {
            localStorage.setItem('epilogueVisited', 'true');
        }
    }, [moduleId]);

    const quizPage = module?.pages?.find(p => p.pageId === 'quiz');
    const hasQuiz = quizPage?.quiz?.questions?.length > 0;
    const menuItems = [
        moduleId !== '10' && module?.pdfPath && {
            name: 'Contents',
            handler: handleContents,
            icon: <BookOpen size={iconSize} />,
        },
        hasVideo && {
            name: 'Video',
            handler: handleVideo,
            icon: <Video size={iconSize} />,
        },
        hasQuiz && {
            name: 'Quiz',
            handler: (e) => {
                e.preventDefault();
                navigate(`/module/${moduleId}/quiz`);
            },
            icon: <ClipboardCheck size={iconSize} />,
        },
        {
            name: 'Feedback',
            handler: (e) => {
                e.preventDefault();
                navigate(`/module/${moduleId}/feedback`);
            },
            icon: <MailCheck size={iconSize} />,
        },
        moduleId === 'epilogue' && {
            name: 'Certificate',
            handler: (e) => {
                e.preventDefault();
                navigate('/certificate');
            },
            icon: <Award size={iconSize} />,
        },
    ].filter(Boolean);

    const formatTime = (seconds) => {
        if (!seconds || isNaN(seconds)) return "0:00";
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
        <div className={onImage ? 'module-menu on-image' : 'module-menu'}>
               <div className={onImage ? 'landing-controls' : 'module-menu-controls'}>
                    {moduleId !== '11' && (
                        <button type="button" onClick={togglePlay} className="play-pause-btn icon-btn">
                            {isPlaying ? <Pause size={iconSize} /> : <Play size={iconSize} />}
                        </button>
                    )}
                    {duration > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '0 10px', color: onImage ? 'white' : '#1F2937' }}>
                            <span style={{ fontSize: '12px', minWidth: '35px', textAlign: 'right' }}>{formatTime(currentTime)}</span>
                            <input
                                type="range"
                                min="0"
                                max={duration}
                                value={currentTime || 0}
                                onChange={(e) => onSeek && onSeek(parseFloat(e.target.value))}
                                style={{ width: 'clamp(80px, 20vw, 120px)', height: '4px', cursor: 'pointer', accentColor: '#D97706' }}
                            />
                            <span style={{ fontSize: '12px', minWidth: '35px' }}>{formatTime(duration)}</span>
                        </div>
                    )}
                    {menuItems.map(item => (
                        <button type="button" key={item.name} onClick={item.handler} className="icon-btn" title={item.name}>
                            {item.icon}
                        </button>
                    ))}
                  {!onImage &&  <button type="button" onClick={handleBack} className="icon-btn" title="Back to Banner">
                        <ArrowLeft size={iconSize} />
                    </button>}
                </div>
        </div>
    );
};

export default ModuleMenu;